<template>
  <div class="student">
    <el-card class="box-card" style="margin-top: 20px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in catogeryList" :key="k">
        </el-tab-pane>
      </el-tabs>
      <el-form :label-width="formLabelWidth" v-if="activeName == 'second'">
        <el-row :gutter="20" style="margin-bottom:20px;">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入优惠券名称" auto-complete="off" clearable style="width:80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="活动时间" prop="createTime">
              <el-date-picker type="datetimerange" style="width:80%" v-model="searchForm.createTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="24">
            <el-button style="text-align: left" type="primary" @click="openGoodsModal" icon="el-icon-plus">商品</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table v-if="activeName != 'second'" key="multipleTable" ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="page.rows" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border @selection-change="selectionChange">
        <!-- <el-table-column type="selection" min-width="40"></el-table-column> -->
        <el-table-column prop="name" label="活动名称"></el-table-column>
        <el-table-column prop="createTime" label="有效时间" width="200">
          <template slot-scope="row">
            <div v-if="row.row.beginDate">起：{{ row.row.beginDate }}</div>
            <div v-if="row.row.beginDate">止：{{ row.row.endDate }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="activityState" label="活动状态"></el-table-column>
        <el-table-column prop="goodsCount" label="商品数量"></el-table-column>
        <el-table-column prop="sellCount" label="活动销量"></el-table-column>
        <el-table-column prop="income" label="收入" align="center">
          <template slot-scope="row">
            <div>{{ row.row.income }}</div>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span class="mainColor" @click="viewAddedAc(scope.row)">查看</span>
              <span class="mainColor" @click="upDownGoods(scope.row)">{{ scope.row.sell == 1 ? '下架' : '上架' }}</span>
              <span class="mainColor" @click="deleteAc(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table v-else key="multipleTable123" ref="multipleTable" :data="createList" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="margin-top: 0px; width: 100%" border @selection-change="selectionChange">
        <el-table-column type="selection" min-width="40"></el-table-column>
        <el-table-column label="商品" minWidth="200" align="center">
          <template slot-scope="row">
            <div style="display: flex">
              <img style="width: 120px; height: 60px" :src="row.row.logo ? row.row.logo : 'http://ncszhgj.oss-cn-hangzhou.aliyuncs.com/tkwx/15743276279534477403800.png'" />
              <div style="margin-left: 10px; width: 130px">
                <span>{{ row.row.name }}</span>
                <span style="display: block">
                  <span style="color: red">￥{{ row.row.price }}</span>
                  <span style="text-decoration: line-through;color: rgb(162, 170, 188); ">￥{{ row.row.originalPrice }}</span>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="limitQuantity" label="拼团人数" minWidth="150px">
          <template slot-scope="scope">
            <div class="flexCell">
              <el-input @change="confirmEdit(scope.row, scope.$index, 'groupPeopleNumber')" v-model="scope.row.groupPeopleNumber" type="number" placeholder="请输入" size="mini"></el-input>
              人
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="limitQuantity" label="拼团时限" minWidth="150px">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.groupTime">
              <el-radio :label="24">24小时</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
        <el-table-column prop="limitQuantity" label="拼团价" minWidth="150px">
          <template slot-scope="scope">
            <div class="flexCell">
              <el-input @change="confirmEdit(scope.row, scope.$index, 'activityPrice')" v-model="scope.row.activityPrice" type="number" placeholder="请输入" size="mini"></el-input>
              元
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="limitQuantity" label="限量" minWidth="150px">
          <template slot-scope="scope">
            <div>{{ scope.row.limitQuantity ? scope.row.limitQuantity : '不限量' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop label="操作" minWidth="200" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span class="mainColor" @click="deleteGoods(scope.$index)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="btnCenter" v-if="activeName == 'second'">
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
      <el-pagination v-if="activeName == 'first'" background layout="total, prev, pager, next" style="margin-top: 20px; text-align: right" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>
    <goods-select ref="goodsSelect" @selectGoodsChange="getSelectGoods"></goods-select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import md5 from "md5";
import goodsSelect from './goodsSelect.vue'
export default {
  components: { goodsSelect },
  data () {
    return {
      activityId: '',
      formLabelWidth: "100px",
      activeName: 'first',
      catogeryList: [
        {
          label: '活动列表',
          name: 'first'
        }, {
          label: '创建拼团',
          name: 'second'
        }
      ],
      groupList: [],
      subjectList: [],
      campusList: [],
      subjectListVisible: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      viewFormVisible: false,
      addFormVisible: true,
      editFormVisible: false,
      importFormVisible: false,
      options: [],
      region: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      searchForm: {
        name: "",
        couponType: '',
        createTime: "",
      },
      regionTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },

      editForm: {
        account: "",
        name: "",
        sex: "",
        card: "",
        email: "",
        address: "",
        remark: "",
      },
      studentDetail: {},
      editFormRules: {
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱号码格式不正确",
          },
        ],
        studentGroupId: [
          {
            required: true,
            message: "请选择学员分组",
            trigger: "blur",
          },
        ],
        card: [
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证号码格式不正确",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字",
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入学生姓名",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "学生姓名长度在1到255个字",
          },
        ],

        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "密码长度在1到255个字",
          },
        ],
      },
      importForm: {},
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/student/upload`,
      fileList: [],
      studentGroupLIst: [],
      loading: false,
      exportLoading: false,
      createList: [],
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  methods: {
    upDownGoods (obj) {
      this.$confirm(`确定${obj.sell == 1 ? '下架' : '上架'}吗`, "系统消息", {
        type: "warning",
      }).then(() => {
        if (obj.sell == 1) {
          var params = {
            "idList": [obj.id],
            type:'拼团'
          }
          this.api.classInfo.activityBatchOff(params).then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          })
        } else {
          var params = {
            "idList": [obj.id],
            type: '拼团'
          }
          this.api.classInfo.activityBatchOn(params).then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.pageList();
            } else {
              this.$message.error(result.message);
            }
          })
        }
      })
    },
    changeRadio (e) {
      this.couponForm.couponType = e.detail.value;
      console.log(this.couponForm.couponType);
    },
    deleteGoods (idx) {
      this.createList.splice(idx, 1)
    },
    confirmEdit (row, idx, type) {
      console.log(row[type], type, 'confirmEdit')
      if(type == 'groupPeopleNumber' && row[type] == 0){
         row[type] = 1
         return this.$message.warning('拼团人数至少有一人！')
      }
      row[type] = row[type].replace(/[^\d]/g, '')
      if (row[type] != "" && row[type] != null) {

      }
    },
    addConfirm () {
      var api = ''
      if (!this.activityId) {
        api = 'addActivity'
      } else {
        api = 'updateActivity'
      }
      if (!this.searchForm.name) {
        this.$message.error('请输入活动名称')
        return false
      } else if (!this.searchForm.beginDate) {
        this.$message.error('请输入活动时间')
        return false
      }
      var activityGoods = []
      this.createList.forEach((v, k) => {
        activityGoods.push({
          "goodsId": v.id,
          "groupTime": v.groupTime,
          "activityPrice": v.activityPrice,
          "groupPeopleNumber": v.groupPeopleNumber,
        })
      })
            if (activityGoods.length === 0) {
        this.$message.error('请添加商品')
        return false
      }
      var params = {
        "name": this.searchForm.name,
        "beginDate": this.searchForm.beginDate,
        "endDate": this.searchForm.endDate,
        type: '拼团',
        "activityGoods": activityGoods
      }
      if (this.activityId) {
        params.id = this.activityId
      }
      this.api.classInfo[api](params).then(res => {
        this.activityId = ''
        if (res.success) {
          this.createList = []
          this.activeName = 'first'
          this.page.pageNumber = 1;
          this.pageList();
          this.searchForm = {
            name: "",
            createTime: "",
          }
          this.$message.success(res.message || '操作成功')
        } else this.$message.warning(res.message)
      })
    },
    getSelectGoods (obj) {
      
      this.$nextTick(() => {
        for (var i = 0; i < obj.length; i++) {
          this.$set(obj[i], 'discount', 0)
          this.$set(obj[i], 'reducePrice', 0)
          this.$set(obj[i], 'activityPrice', obj[i].price)
          this.$set(obj[i], 'limitQuantity', 0)

          this.$set(obj[i], 'groupTime', 24)
          this.$set(obj[i], 'groupPeopleNumber', 1)
          // obj[i].discount = '0'
          // obj[i].reducePrice = '0'
          // obj[i].activityPrice = '0'
          // obj[i].limitQuantity = '0'
          console.log(obj[i], 'obj')
        }
        let goods = []
        goods = Array.concat(obj, this.createList)
        console.log(this.createList,2333);
        this.createList = goods
        console.log(this.createList, 'getSelectGoods')
      })
    },
    openGoodsModal () {
      this.$refs.goodsSelect.openGoodsModal();
    },
    handleClick (val) {
      console.log(this.activeName)
      this.activityId = ''
      this.searchForm.name = ''
      this.searchForm.createTime = ''
      this.searchForm.beginDate = ''
      this.searchForm.endDate = ''
      this.createList = []
      if (this.activeName == 'first') {
        this.page.pageNumber = 1;
        this.pageList();
      }
    },
    campusChange (val) {
      this.searchForm.campusId = val[2];
    },
    // 是否启用
    updateSwitching (row) {
      console.log(row, 99999999);
      var para = {
        "id": row.id, //学员id
        "state": row.state//是否启用：是1否-1
      }
      this.api.student
        .studentOnOrOff(para)
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    seeOverviewDetails (obj) {
      this.$router.push(`/studentGoodsContent?id=${obj.id}`);
    },
    importExcel () {
      window.open(
        // "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/student/%E5%AD%A6%E7%94%9F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls"
        "http://68wx--test.oss-cn-hangzhou.aliyuncs.com/materials/16190125872036.xls"
      );
    },
    addRegionChange () {
      this.addForm.regionId = this.region[1];
    },
    editRegionChange () {
      this.editForm.regionId = this.region[1];
    },
    getPageList (id) {
      this.api.goodsInfo
        .getStudentBuyGoodsList({ id: id })
        .then((result) => {
          if (result.data) {
            this.subjectList = result.data;
          } else {
            this.subjectList = [];
          }
          this.subjectListVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },

    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      console.log("val", val);
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
      console.log("this.ids", this.ids);
    },
    getStudent () {
      this.api.student
        .getStudent({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          this.region = this.editForm.regionId;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStudentDetail () {
      this.api.student
        .getStudentDetail({
          id: this.selection,
        })
        .then((result) => {
          this.studentDetail = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      var params = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        type: '拼团',
      }
      this.api.classInfo.activityPageList(params)
        .then((result) => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addStudent () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.addForm.campusId) {
            this.addForm.campusId = this.addForm.campusId[2];
          }
          this.addForm.agentId = this.loginData.agentId;
          this.api.student
            .addStudent(this.addForm)
            .then((result) => {
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateStudent () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          // console.log(typeof this.editForm.campusId);
          if (typeof this.editForm.campusId == "object") {
            let index = this.editForm.campusId.length;
            this.editForm.campusId = this.editForm.campusId[index - 1];
          }
          this.editForm.agentId = this.loginData.agentId;
          this.api.student
            .updateStudent(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteStudent (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteStudent () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.student
            .deleteStudent(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    reset () {
      this.searchForm.studentGroupIds = [];
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess (response, file, fileList, $event) {
      this.importForm = response.data;
    },
    deleteAc (obj) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      }).then(() => {
        var params = [{ "id": obj.id }]
        this.api.classInfo.deleteActivity(params).then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
      })
    },
    viewAddedAc (obj) {
      var params = {
        id: obj.id
      }
      this.api.classInfo.getActivityById(params).then((res) => {
        if (!res.success) return false
        this.activityId = res.data.id
        this.searchForm.name = res.data.name
        this.searchForm.createTime = [res.data.beginDate, res.data.endDate]
        if (res.data.activityGoods && res.data.activityGoods.length > 0) {
          res.data.activityGoods.forEach(v => {
            this.createList.push({
              discount: v.discount,
              reducePrice: v.reducePrice,
              limitQuantity: v.limitQuantity,
              reducePrice: v.reducePrice,
              activityPrice: v.activityPrice,
              logo: v.goodsInfo.logo,
              name: v.goodsInfo.name,
              id: v.goodsId,
              price: v.goodsInfo.price,
              originalPrice: v.goodsInfo.originalPrice,
              groupPeopleNumber: v.groupPeopleNumber,
              groupTime: v.groupTime,
            })
          })
        } else {
          res.data.activityGoods = []
        }
        this.activeName = 'second'
      })
    },
    checkboxT (row, rowIndex) {
      if (row.remark == "") {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "searchForm.createTime": function (newVal) {
      if (newVal) {
        this.searchForm.beginDate = newVal[0];
        this.searchForm.endDate = newVal[1];
      } else {
        this.searchForm.createTime = [];
        this.searchForm.beginDate = "";
        this.searchForm.endDate = "";
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getStudent();
      }
    },
    viewFormVisible: function (newVal) {
      if (!newVal) {
        this.studentDetail = {};
        this.$refs.studentDetail.resetFields();
      } else {
        this.getStudentDetail();
      }
    },
  },
  mounted () {
    this.pageList();
  },
};
</script>
<style scoped>
.answer {
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  color: #409eff;
  text-overflow: ellipsis;
}

.courseManage {
  padding: 3px 14px 3px 14px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}

.style1 {
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
}

.style2 {
  background: rgb(255, 185, 28);
  border: solid 1px rgb(255, 185, 28);
}

.style3 {
  background: rgb(162, 170, 188);
  border: solid 1px rgb(162, 170, 188);
}
</style>
<style lang="less">
.student {
  .el-select {
    width: 100% !important;
  }

  .viewForm {
    .el-dialog__body {
      padding-top: 0px;
    }

    .el-form-item {
      margin-bottom: 0px !important;
    }
  }

  .importForm {
    .el-upload-list {
      display: none !important;
    }
  }
}

.goodBox {
  display: flex;
}

.priceGods {
  display: flex;
  flex-direction: column;
}

.goodsImg {
  width: 120px;
  height: 90px;
}

.btnCenter {
  display: flex;
  margin: 20px 0;
  justify-content: center;
}

.stench {
  width: 64px;
  padding: 0 5px;
  height: 18px;
  border: 1px solid rgb(220, 90, 85);
  color: rgb(220, 90, 85);
  border-radius: 4px;
  font-size: 10px;
  text-align: center;
  background: rgb(255, 255, 255);
  margin-right: 10px;
}

.flexCell {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;

  .el-input__inner {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/conentSaleCenter/groupReserve.vue